import {
  GET_PRODUCTOPTION,
  GET_PRODUCTOPTION_SUCCESS,
  GET_PRODUCTOPTION_FAIL,
  DELETE_PRODUCTOPTION,
  DELETE_PRODUCTOPTION_SUCCESS,
  DELETE_PRODUCTOPTION_FAIL,
  UPDATE_PRODUCTOPTION,
  UPDATE_PRODUCTOPTION_SUCCESS,
  UPDATE_PRODUCTOPTION_FAIL,
  ADD_NEW_PRODUCTOPTION,
  ADD_PRODUCTOPTION_SUCCESS,
  ADD_PRODUCTOPTION_FAIL,
  PRODUCTOPTION_LOADING,
  PRODUCTOPTION_RESET,
} from "./actionType";

export const resetProductOptionState = (actionType) => ({
  type: PRODUCTOPTION_RESET,
  payload: { actionType },
});

export const getProductOptionSuccess = (actionType, data) => ({
  type: GET_PRODUCTOPTION_SUCCESS,
  payload: { actionType, data },
});

export const getProductOptionFail = (actionType, error) => ({
  type: GET_PRODUCTOPTION_FAIL,
  payload: { actionType, error },
});

export const getProductOption = data => ({
  type: GET_PRODUCTOPTION,
  payload: data,
});

export const getProductOptionLoading = () => ({
  type: PRODUCTOPTION_LOADING
});

export const deleteProductOption = data => ({
  type: DELETE_PRODUCTOPTION,
  payload: data,
});

export const deleteProductOptionSuccess = data => ({
  type: DELETE_PRODUCTOPTION_SUCCESS,
  payload: data,
});

export const deleteProductOptionFail = error => ({
  type: DELETE_PRODUCTOPTION_FAIL,
  payload: error,
});

export const updateProductOption = data => ({
  type: UPDATE_PRODUCTOPTION,
  payload: data,
});

export const updateProductOptionFail = error => ({
  type: UPDATE_PRODUCTOPTION_FAIL,
  payload: error,
});

export const updateProductOptionSuccess = data => ({
  type: UPDATE_PRODUCTOPTION_SUCCESS,
  payload: data,
});

export const addNewProductOption = data => ({
  type: ADD_NEW_PRODUCTOPTION,
  payload: data,
});

export const addProductOptionSuccess = data => ({
  type: ADD_PRODUCTOPTION_SUCCESS,
  payload: data,
});

export const addProductOptionFail = error => ({
  type: ADD_PRODUCTOPTION_FAIL,
  payload: error,
});